
import './App.css';
import React from 'react';
import Explore from './pages/Explore';
import PixelArt from './pages/PixelArt';
import AIArt from './pages/AIArt';
import AlgoArt from './pages/AlgoArt';
import Login from './pages/Login';
import Profile from './pages/Profile';
import Admin from './pages/Admin';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LessonsStudent from './pages/LessonsStudent';
import Classroom from './pages/Classroom';
import FirstLesson from './pages/lessons/FirstLesson';
import SecondLesson from './pages/lessons/SecondLesson'
import ThirdLesson from './pages/lessons/ThirdLesson';
import FourthLesson from './pages/lessons/FourthLesson';
import { Nice } from './pages/lessons/LessonTemp'
import { ColorContext } from './context/ColorContext';

// Main app component
// This is where the app's frontend routes are defined

const colorContext = {
  white: "#ffffff",
  darkPurple: "#752a8b",
  lightPurple: "#ae5ec6",
  pink: "#b418ac",
  yellow: "#ffac30",
  blue: "#56becf"
};

class App extends React.Component {

  render() {
    // Return router that serves page components at the following routes:
    return (
      <BrowserRouter>
        <ColorContext.Provider value={colorContext}>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/explore" element={<Explore />} />
            <Route path="/ai-art" element={<AIArt />} />
            <Route path="/algorithmic-art" element={<AlgoArt />} />
            <Route path="/pixel-art" element={<PixelArt />} />
            <Route path="/lessons" element={<LessonsStudent />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/admin" element={<Admin />} />
            {/* <Route path="/lessons/first" element={<FirstLesson />} /> */}
            {/* <Route path="/lessons/second" element={<SecondLesson />} /> */}
            {/* <Route path="/lessons/third" element={<ThirdLesson />} /> */}
            {/* <Route path="/lessons/fourth" element={<FourthLesson />} /> */}
            <Route path="/classroom" element={<Classroom />} />
            <Route path="*" element={<Navigate to="/explore" replace />} />
          </Routes>
        </ColorContext.Provider>
      </BrowserRouter>
    );
  }
}

export default App;